module.exports = __webpack_public_path__ + "img/lock.91d7f130.png";